import { runDiscoveryRead } from "./discoveryReadQueue.js";
import { useEffect, useState } from "react";
import { runQuery, rowsToObjects } from "./analyticsClient.js";

// A changed request hides the previous response during render, before effects
// run. Cleanup also rejects late responses from an earlier authorization scope.
export function useDiscoveryQuery(spec, contextKey, enabled = true) {
    const key = enabled && spec ? JSON.stringify({ spec, contextKey }) : null;
    const [result, setResult] = useState({ key: null, status: "idle", rows: [], error: null });
    useEffect(() => {
        if (!key) return undefined;
        const { spec: querySpec } = JSON.parse(key);
        const controller = new AbortController();
        let active = true;
        const timeout = setTimeout(() => {
            active = false;
            controller.abort();
            setResult({ key, status: "error", rows: [], error: new Error("The query timed out. Refresh to try again.") });
        }, 30000);
        runDiscoveryRead(() => runQuery(querySpec, { signal: controller.signal, requestContext: contextKey }), { signal: controller.signal }).then(rowsToObjects).then((rows) => {
            if (active) setResult({ key, status: "ready", rows, error: null });
        }, (error) => {
            if (active) setResult({ key, status: "error", rows: [], error });
        }).finally(() => clearTimeout(timeout));
        return () => { active = false; clearTimeout(timeout); controller.abort(); };
    }, [key, contextKey]);
    if (!key) return { status: "idle", rows: [], error: null };
    return result.key === key ? result : { status: "loading", rows: [], error: null };
}
